import React, { useEffect, useState } from 'react';
import { fetchNews } from '../services/api';
import { Table, Pagination, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';

const StockNews = ({ symbol }) => {
  const [news, setNews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  useEffect(() => {
    const loadNews = async () => {
      try {
        const newsData = await fetchNews(symbol);
        setNews(newsData);
      } catch (error) {
        toast.error('Error fetching stock news');
      }
    };

    loadNews();
  }, [symbol]);

  const totalItems = news.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentNews = news.slice(startIndex, endIndex);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Card className='my-4'>
      <Card.Header className='border-bottom'>
        <h2 className='m-0 h5'>Top News</h2>
      </Card.Header>
      <Card.Body>
        <Table striped bordered hover responsive className='m-0'>
          <thead>
            <tr>
              <th>Title</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {currentNews.map((item, index) => (
              <tr key={index}>
                <td>
                  <a href={item.url} target="_blank" className='text-link text-primary' rel="noopener noreferrer">
                    {item.headline}
                  </a>
                </td>
                <td>{item.source}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
      <Card.Footer className='border'>
        {totalPages > 1 && (
          <Pagination className="m-0" style={{ overflowX: 'auto', margin: '0 auto' }}>
            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
            {[...Array(totalPages).keys()].map((page) => (
              <Pagination.Item key={page + 1} active={page + 1 === currentPage} onClick={() => handlePageChange(page + 1)}>
                {page + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
          </Pagination>
        )}
      </Card.Footer>
    </Card>
  );
};

export default StockNews;
